import { WalletCondition } from '../models/wallet-condition.model';
import { CustomerWallet } from '../models/customer-wallet.model';

export class WalletInititation {
    protected walletCondition: WalletCondition;
    protected wallet: CustomerWallet;
    protected orderAmount: number = 0;
    public activityAmount = 0;
    public loyaltyAmount = 0;
    constructor(condition: WalletCondition, wallet: CustomerWallet, orderAmount: number = 0) {
        this.walletCondition = condition;
        this.wallet = wallet;
        this.orderAmount = orderAmount;
    }
    
      checkWalletCondition(): number {
        let isLoyaltyCoin: boolean = false;
        let isActivityCoin: boolean = false;
        let coinL: number = 0;
        let coinA: number = 0;
        // const isLoyalty: boolean = this.wallet.loyaltyWallet === 0 ? false : true;
        const isLoyalty: boolean = !!this.wallet.loyaltyWallet;
        // const isActivity: boolean = this.wallet.activityWallet === 0 ? this.wallet.eventWallet === 0 ? this.wallet.referWallet === 0 ? false : true : true: true;
        const isActivity: boolean = !!this.wallet.activityWallet || !!this.wallet.eventWallet || !!this.wallet.referWallet;
        if (isLoyalty && !!this.walletCondition.loyaltyUsingPercentage) {
          coinL = this.wallet.loyaltyWallet * this.walletCondition.loyaltyUsingPercentage / 100;
          // isLoyaltyCoin = this.walletSwitch(this.walletCondition.isLoyaltyMinimum, this.walletCondition.isLoyaltyMaximum,
          //                                   this.wallet.loyaltyWallet, this.walletCondition.loyaltyMinimumOrder, this.walletCondition.loyaltyMaximumOrder)
        }
        if (isActivity && !!this.walletCondition.activityUsingPercentage) {
          coinA = this.wallet.activityWallet * this.walletCondition.activityUsingPercentage / 100;
          // const activityAmount = this.wallet.activityWallet + this.wallet.eventWallet + this.wallet.referWallet;
          // isActivityCoin = this.walletSwitch(this.walletCondition.isActivityMinimumOrder, this.walletCondition.isActivityMaximumOrder,
                                            //  this.wallet.activityWallet, this.walletCondition.activityMinimumOrder, this.walletCondition.activityMaximumOrder);
        } 
          if (!!coinL)  coinL = this.checkMinimumAmount(this.walletCondition.isLoyaltyMinimum, coinL, this.walletCondition.loyaltyMinimumOrder);
          if (!!coinL)  coinL = this.checkMaximumAmount(this.walletCondition.isLoyaltyMaximum, coinL, this.walletCondition.loyaltyMaximumOrder);
          if (!!coinA)  coinA = this.checkMinimumAmount(this.walletCondition.isActivityMinimumOrder, coinA, this.walletCondition.activityMinimumOrder);
          if (!!coinA) coinA = this.checkMaximumAmount(this.walletCondition.isActivityMaximumOrder, coinA, this.walletCondition.activityMaximumOrder);
          let totalCoin: number = coinL + coinA;
          if (this.orderAmount === totalCoin) {
            if (!!coinL) coinL--;
            else if (!!coinA) coinA--;
          } else if (this.orderAmount < totalCoin) {
            let balanceCoin: number = totalCoin - this.orderAmount;
            if (coinL > balanceCoin) {
              coinL = coinL - balanceCoin - 1;
            } else if (coinL === balanceCoin) {
              coinL = 0;
            } else {
              coinA = coinA - (balanceCoin - coinL) - 1;
              coinL = 0;
            }
          }
        // coinL = isLoyaltyCoin === true ? this.wallet.loyaltyWallet * this.walletCondition.loyaltyUsingPercentage / 100 : 0;
        // const activityCal: number = this.wallet.activityWallet + this.wallet.eventWallet + this.wallet.referWallet;
        // coinA = isActivityCoin === true ? activityCal * this.walletCondition.activityUsingPercentage / 100 : 0;
        this.loyaltyAmount = coinL;
        this.activityAmount = coinA;
        return coinL + coinA;
       }
       protected walletSwitch(min: boolean = false, max: boolean = false, amount: number, min_amount: number, max_amount: number) {
        if(min === true && max === true) {
          return min_amount <= amount && amount <= max_amount ? true : false;
        } else if (min === true && max === false) {
          return min_amount <= amount ? true : false;
        } else if (min === false && max === true) {
          return amount <= max_amount ? true : false;
        } else {
          return true
        }
      }
      protected checkMinimumAmount(min: boolean = false, amount: number = 0, minimumAmount: number = 0) {
        if (min && amount < minimumAmount) {
          return 0;
        } else {
          return amount;
        }
      }
      protected checkMaximumAmount(max: boolean = false, amount: number = 0, maximumAmount: number = 0) {
        if (max && amount > maximumAmount) {
          return maximumAmount;
        } else {
          return amount;
        }
      }
      
}